@if (hasDeadline) {
<p class="mb-3">
  {{ 'AuthSecurity.mfa_nudge_body' | translate:{date: enforceDate, days: daysRemaining} }}
</p>
} @else {
  <p class="mb-3">{{ 'AuthSecurity.mfa_nudge_body_now' | translate }}</p>

}


<div class="d-flex justify-content-end flex-wrap">
  @if (dismissible) {
  <button type="button" class="btn btn-default me-2" (click)="remindLater()">
    {{ 'AuthSecurity.mfa_nudge_later' | translate }}
  </button>
  }
  @if (deferrable) {
  <button type="button" class="btn btn-default me-2" (click)="deferForAWeek()">
    {{ 'AuthSecurity.mfa_nudge_skip_week' | translate:{days: deferralDays} }}
  </button>
  }
  <button type="button" class="btn btn-primary" (click)="enableNow()">
    {{ 'AuthSecurity.mfa_nudge_enable' | translate }}
  </button>
</div>
